<template>
  <div>
    <img
      v-if="file.type === 'image'"
      :src="file.url"
      class="pl-chat-list-file-img"
      alt=""
      @click.stop="$emit('activateGallery')"
    />

    <div v-else class="flex-container align-end">
      <v-icon color="rgba(255,255,255,0.8)" size="30"> description </v-icon>

      <a :href="file.url" target="_blank">
        {{ file.originName }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.pl-chat-list-file-img {
  max-width: 100%;
}
</style>
